import React from 'react';
import { Link } from 'react-router-dom';
import IMAGES from '../config/images';

const posts = [
  { id: 1, title: 'How to Choose the Perfect Rug for Your Living Room', cat: 'Style Guide', date: 'Mar 2025', excerpt: 'Size, material, and pattern — learn how to match your space with the right handcrafted rug.', img: IMAGES.livingRoom },
  { id: 2, title: 'The Art of Hand-Knotting: A Dying Craft Preserved', cat: 'Heritage', date: 'Feb 2025', excerpt: 'Inside the villages of Bhadohi, master weavers create masterpieces knot by knot.', img: IMAGES.story },
  { id: 3, title: 'Wool vs Silk: Which Material Is Right for You?', cat: 'Material Guide', date: 'Jan 2025', excerpt: 'Understanding durability, texture, and luxury of different rug materials.', img: IMAGES.bedroom },
  { id: 4, title: '5 Ways to Style a Statement Rug in Modern Interiors', cat: 'Interior Design', date: 'Dec 2024', excerpt: 'Discover how designers use handcrafted rugs as stunning focal points.', img: IMAGES.diningRoom },
  { id: 5, title: 'Understanding Rug Knot Density', cat: 'Education', date: 'Nov 2024', excerpt: 'A guide to reading knot count, pile height, and weave type quality metrics.', img: IMAGES.products[0] },
  { id: 6, title: 'Caring for Handmade Rugs', cat: 'Care', date: 'Oct 2024', excerpt: 'Keep your handcrafted investment looking pristine for decades.', img: IMAGES.products[1] },
];

export default function Blog() {
  return (
    <div style={{ background: '#fbfaee' }}>
      <section style={{ textAlign: 'center', padding: '60px 20px 50px' }}>
        <span className="bl-lbl">THE JOURNAL</span>
        <h1 className="bl-h1">Stories, Guides &amp;<br/>Design Inspiration</h1>
        <p className="bl-sub">Insights from the world of handcrafted rugs, interior design, and artisan heritage.</p>
      </section>

      <section style={{ padding: '0 60px 60px', maxWidth: 1200, margin: '0 auto' }}>
        <Link to="#" className="bl-feat">
          <div className="bl-feat-img" style={{ backgroundImage: `url("${posts[0].img}")` }}></div>
          <div className="bl-feat-info">
            <span className="bl-cat">{posts[0].cat}</span>
            <h2 className="bl-feat-t">{posts[0].title}</h2>
            <p className="bl-feat-ex">{posts[0].excerpt}</p>
            <span className="bl-date">{posts[0].date}</span>
          </div>
        </Link>
      </section>

      <section style={{ padding: '0 60px 80px', maxWidth: 1200, margin: '0 auto' }}>
        <div className="bl-grid">
          {posts.slice(1).map(p => (
            <Link to="#" key={p.id} className="bl-card">
              <div className="bl-card-img" style={{ backgroundImage: `url("${p.img}")` }}></div>
              <span className="bl-cat">{p.cat}</span>
              <h3 className="bl-card-t">{p.title}</h3>
              <p className="bl-card-ex">{p.excerpt}</p>
              <span className="bl-date">{p.date}</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="bl-nl">
        <h2 className="bl-nl-t">Stay Inspired</h2>
        <p className="bl-nl-s">Join our newsletter for design tips, new arrivals, and exclusive stories.</p>
        <div className="bl-nl-f">
          <input type="email" placeholder="Your email address" />
          <button>Subscribe</button>
        </div>
      </section>

      <style>{`
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif:wght@400;700&family=Inter:wght@300;400;500;600&display=swap');
.bl-lbl{display:block;font-family:Inter,sans-serif;font-size:11px;font-weight:600;letter-spacing:2.5px;text-transform:uppercase;color:#785600;margin-bottom:14px}
.bl-h1{font-family:'Noto Serif',Georgia,serif;font-size:3rem;font-weight:400;color:#1b1c15;margin:0 0 16px;line-height:1.1}
.bl-sub{font-family:Inter,sans-serif;font-size:15px;color:#4f4535;max-width:500px;margin:0 auto;line-height:1.7}
.bl-cat{font-family:Inter,sans-serif;font-size:10px;font-weight:600;letter-spacing:2px;text-transform:uppercase;color:#785600;display:block;margin-bottom:8px}
.bl-date{font-family:Inter,sans-serif;font-size:11px;color:#aaa}
.bl-feat{display:flex;text-decoration:none;color:inherit;background:#f5f4e8;overflow:hidden}
.bl-feat:hover{opacity:.95}
.bl-feat-img{flex:1.2;min-height:360px;background-size:cover;background-position:center}
.bl-feat-info{flex:1;padding:48px;display:flex;flex-direction:column;justify-content:center}
.bl-feat-t{font-family:'Noto Serif',Georgia,serif;font-size:1.8rem;font-weight:400;color:#1b1c15;margin:0 0 16px;line-height:1.3}
.bl-feat-ex{font-family:Inter,sans-serif;font-size:14px;color:#4f4535;line-height:1.8;margin:0 0 20px}
.bl-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.bl-card{text-decoration:none;color:inherit}
.bl-card:hover{opacity:.9}
.bl-card-img{width:100%;aspect-ratio:16/10;background-size:cover;background-position:center;background-color:#efeee3;margin-bottom:16px}
.bl-card-t{font-family:'Noto Serif',Georgia,serif;font-size:1.1rem;font-weight:400;color:#1b1c15;margin:0 0 10px;line-height:1.35}
.bl-card-ex{font-family:Inter,sans-serif;font-size:13px;color:#4f4535;line-height:1.7;margin:0 0 12px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
.bl-nl{padding:80px 20px;background:#1b1c15;text-align:center}
.bl-nl-t{font-family:'Noto Serif',Georgia,serif;font-size:2rem;color:#fff;margin:0 0 12px}
.bl-nl-s{font-family:Inter,sans-serif;font-size:14px;color:rgba(255,255,255,.6);line-height:1.7;margin:0 0 28px}
.bl-nl-f{display:flex;gap:10px;max-width:450px;margin:0 auto}
.bl-nl-f input{flex:1;padding:14px 18px;border:1px solid rgba(255,255,255,.15);background:rgba(255,255,255,.05);color:#fff;font-family:Inter,sans-serif;font-size:13px;border-radius:4px;outline:none}
.bl-nl-f input::placeholder{color:rgba(255,255,255,.3)}
.bl-nl-f button{padding:14px 28px;background:linear-gradient(135deg,#785600,#986d00);color:#fff;border:none;font-family:Inter,sans-serif;font-size:12px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;cursor:pointer;border-radius:4px}
@media(max-width:900px){.bl-feat{flex-direction:column}.bl-feat-img{min-height:250px}.bl-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:480px){.bl-grid{grid-template-columns:1fr}.bl-nl-f{flex-direction:column}.bl-h1{font-size:2rem}}
      `}</style>
    </div>
  );
}
